module.exports = __webpack_public_path__ + "media/images/emblems/Hubersdorf-blason-6417a54bc5cab758ee1d057dd17a840c.png";